import { jsx as A } from "react/jsx-runtime";
import { forwardRef as F } from "react";
import { renderTimeViewClock as n, TimePicker as $, StaticTimePicker as b } from "@mui/x-date-pickers";
import c, { useTheme as N } from "styled-components";
import L from "../../../icons/chevron-left.js";
import R from "../../../icons/chevron-right.js";
import V from "../../../icons/clock.js";
import { variants as s } from "../../../theme/utils/styleUtils.js";
import z from "../../IconButton/IconButton.js";
import D, { DesktopPickersLayout as j } from "./CustomLayout.js";
import O from "./SpecificTextField.js";
const q = c(V).withConfig({
  displayName: "StyledTimeIcon"
})([
  "height:16px;width:16px;color:",
  ";"
], ({ theme: t }) => t.primaryFill), a = c(z).withConfig({
  displayName: "StyledIconButton"
})([
  "margin:0px;"
]), p = (t, m) => {
  const {
    className: l,
    // @ts-expect-error - TODO: Fix component typing.
    open: E,
    slots: d,
    slotProps: u = {},
    variant: i = "dynamic",
    onChange: e,
    viewRenderers: P = {
      hours: n,
      minutes: n,
      seconds: n
    },
    ...f
  } = t, o = N(), h = i === "dynamic" ? $ : b, x = {
    style: {
      boxShadow: `0px 4px 20px 0px ${o.primaryShadow}`,
      marginTop: "4px",
      backgroundColor: `${o.isLightTheme ? o.primaryBackground : o.secondaryBackground}`
    }
  }, r = f;
  r.format || delete r.format;
  const {
    // @ts-expect-error - TODO: Fix component typing.
    textField: I,
    previousIconButton: y,
    nextIconButton: B,
    // @ts-expect-error - TODO: Fix component typing.
    switchViewButton: G,
    // @ts-expect-error - TODO: Fix component typing.
    desktopPaper: k,
    // @ts-expect-error - TODO: Fix component typing.
    inputAdornment: T,
    toolbar: w,
    actionBar: g,
    ...v
  } = u, S = (C) => {
    e && e(C.target.value);
  };
  return (
    // @ts-expect-error - TODO: Fix component typing.
    /* @__PURE__ */ A(h, {
      ...r,
      slots: {
        textField: O,
        leftArrowIcon: L,
        rightArrowIcon: R,
        openPickerIcon: q,
        previousIconButton: a,
        nextIconButton: a,
        layout: i === "dynamic" ? j : D,
        ...d
      },
      slotProps: {
        textField: {
          ref: m,
          className: l,
          onClear: S,
          ...I
        },
        previousIconButton: {
          size: "small",
          variant: s.contained,
          ...y
        },
        nextIconButton: {
          size: "small",
          variant: s.contained,
          ...B
        },
        desktopPaper: {
          ...x,
          ...k
        },
        inputAdornment: {
          classes: {
            root: "inputAdornmentRoot"
          },
          ...T
        },
        toolbar: {
          hidden: !0,
          ...w
        },
        actionBar: {
          hidden: !0,
          actions: [],
          ...g
        },
        ...v
      },
      onChange: e,
      viewRenderers: P
    })
  );
};
p.displayName = "TimePicker";
const oo = /* @__PURE__ */ F(p);
export {
  oo as default
};
